import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lib-cdw-step-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cdw-step-indicator.component.html',
  styleUrls: ['./cdw-step-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CdwStepIndicatorComponent {
  @Input() stepNumber = 1;
  @Input() enabled = true;
  @Input() enabledColor = '#007AFF'; // Default blue color
  @Input() disabledColor = '#D1D5DB'; // Default gray color
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  get circleSize(): string {
    switch (this.size) {
      case 'small':
        return '32px';
      case 'large':
        return '48px';
      case 'medium':
      default:
        return '40px';
    }
  }

  get fontSize(): string {
    switch (this.size) {
      case 'small':
        return '14px';
      case 'large':
        return '20px';
      case 'medium':
      default:
        return '16px';
    }
  }
}